/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 1/4/15
 * Time: 3:10 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var KPsSnippetsCompositeModel = {};

    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {
        KPsSnippetsCompositeModel = Backbone.Model.extend({
            name: "KPsSnippetsCompositeModel"

        });
    });
    return KPsSnippetsCompositeModel;
});
